import 'reflect-metadata';
import {
  container,
  instancePerContainerCachingFactory,
  registry,
} from 'tsyringe';
import {
  kNameOfTesterWindowService,
  ITesterWindowService,
} from '../shared/interfaces/tester-window-service.interface';
import { LoggerService } from '../shared/services/logger.service';
import { WindowsTunnelDataService } from '../shared/services/windows-tunnel-data.service';
import { TesterController } from './tester.controller';
import './tester.scss';

// -----------------------------------------------------------------------------
@registry([
  {
    token: kNameOfTesterWindowService,
    useFactory: instancePerContainerCachingFactory<ITesterWindowService>(
      (c) => {
        const tunnelDataService = c.resolve(WindowsTunnelDataService);
        return tunnelDataService.get(kNameOfTesterWindowService);
      },
    ),
  },
])
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
class TesterRegistry {}

// -----------------------------------------------------------------------------
const startup = () => {
  LoggerService.setup('Overwolf Promotions Tester');
  const controller = container.resolve(TesterController);
  controller.run();
};

startup();
